
import { Vue, Component, Prop } from "vue-property-decorator";
import CardSingleChip from "@/components/card/CardSingleChip.vue";
import CardBodyItem from "@/components/card/CardBodyItemNew.vue";
import ItemChipReviewNew from "@/components/common/ItemChipReviewNew.vue";
import { NO_INFORMATION } from "@/data/placeholders";
import ItemChipsData from "@/entities/ItemChipsData";

@Component({
  components: {
    CardBodyItem,
    ItemChipReviewNew,
    CardSingleChip,
  },
})
export default class CardBodySingleChip extends Vue {
  @Prop({ type: String, required: true }) readonly label!: string;
  @Prop({ type: Object, required: true }) readonly chipDetails!: ItemChipsData;
  @Prop({ type: Boolean, default: false }) readonly wide!: boolean;
  @Prop({ type: Boolean, default: "" }) readonly labelStyle!: String;
  @Prop({ type: Boolean, default: "" }) readonly background!: String;
  @Prop({ type: Boolean, default: false }) readonly clickableText!: boolean;
  @Prop({ type: Boolean || String, default: false }) readonly newAvatarColor!:
    | String
    | Boolean;
  @Prop({ type: Boolean, default: false })
  readonly customContainerClass!: String;
  @Prop({ type: Boolean, default: false }) readonly withAvatar!: boolean;
  @Prop({ type: String, default: "text-label" })
  readonly noContentClasses!: string;
  @Prop({ type: Object, default: undefined }) readonly item?: ItemChipsData;

  get noContent(): boolean {
    return !this.chipDetails;
  }

  noContentPlaceholder = `No ${this.label}`;
}
